<template>
  <div id="home" class="pa-0 w-full overflow-hidden relative">
    <!-- <CoronaDialog ref="coronaDialog" /> -->
    <!-- <v-tooltip right>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" absolute elevation="5" icon fab :small="$vuetify.breakpoint.xs"
          :class="$vuetify.breakpoint.xs ? 'mt-3 mr-3 right-0' : 'mt-10 ml-10'" color="green darken-1"
          @click="$refs.coronaDialog.open()">
          <v-icon :large="!$vuetify.breakpoint.xs">mdi-virus-outline</v-icon>
        </v-btn>
      </template>
      <span>{{ $t("corona") }}</span>
    </v-tooltip> -->
    <div :class="$vuetify.breakpoint.xs ? '' : 'container'">
      <v-row class="px-3 text-body-2 mt-3 grey--text">
        <breadcrumb color="grey darken-4" trans="home.breadcrumb." v-for="(selector, i) in selectors" :key="i"
          :selector="selector">
          <div class="grey-dot mx-3 primary lighten-2 align-self-center" v-if="i + 1 < selectors.length"></div>
        </breadcrumb>
        <div class="d-flex">
          <div class="grey-dot mx-3 primary lighten-2 align-self-center" ></div>
          <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
              <v-btn 
                v-bind="attrs" v-on="on"
                :href="`${$connection}/forms/Vereinszeitung.pdf`"
                text
                color="gray darken-4"
                class="text-capitalize text-body-2"
                x-small
              >Vereinszeitung
              <v-icon class="ml-1 orange--text" x-small>mdi-open-in-new</v-icon>
            </v-btn>
          </template>
          <span>Vereinszeitung herunterladen</span>
        </v-tooltip>
      </div>
      </v-row>

      <!-- <div class="red pa-5 mt-8" :class="$vuetify.breakpoint.mobile? '':'rounded-sm  elevation-1'">
        <div class="text-center text-body-1"><span class="font-weight-bold white--text">
          Absage des Volkslaufs "Sport gegen Armut" am 28. Juni 2026! 
          <v-btn 
            v-bind="attrs" v-on="on"
            :href="`${$connection}/forms/Absage_Volkslauf_Sport_gegen_Armut.pdf`"
      
            color="white darken-4"
            class="text-capitalize ml-4 text-body-2 justify-center"
          >Mehr Informationen
          
        </v-btn>
        </span></div>
      </div> -->

      <div class="white pa-5 mt-8" :class="$vuetify.breakpoint.mobile? '':'rounded-sm  elevation-1'" style="background: linear-gradient(92.07deg, #FFF2CC -22.22%, rgba(255, 246, 221, 0.636592) 47.93%, rgba(255, 253, 249, 0) 170.8%);">
        <div class="text-center text-body-1"><span class="font-weight-bold">Freiwilliges Soziales Jahr in unserer Turngemeinde. </span> Bewirb dich für den <span class="font-weight-bold">01.09</span> unter <a href="mailto:fsj@tgschwalbach.de"
            target="_blank">fsj@tgschwalbach.de</a>. Die TG Schwalbach bekennt sich zum Kindeswohl. Unter <a href="mailto:kindeswohl@tgschwalbach.de" target="_blank">kindeswohl@tgschwalbach.de</a> können Sie unsere Kindeswohl - Beauftragten erreichen.</div>

        <div class="text-center flex justify-center">
          <v-btn :to="{ name: 'FSJ' }" color="primary" elevation="1" class="text-capitalize text-decoration-none px-10 mt-2">
            Mehr zum FSJ
          </v-btn>
<!--          <v-btn :href="`mailto:kindeswohl@tgschwalbach.de`" color="green" elevation="1" class="text-capitalize white&#45;&#45;text px-10 mt-2 ml-5">-->
<!--            Kindeswohl-->
<!--          </v-btn>-->
        </div>

      </div>

      <v-row class="mt-10">
        <v-col cols="12" lg="8" class="w-full text-center">
          <div class="mb-8 text-center" :class="$vuetify.breakpoint.mobile ? 'text-h6' : 'text-h5'">
            {{ $t("home.infos") }}
          </div>
          <v-carousel cycle hide-delimiter-background :height="
            $vuetify.breakpoint.mobile
              ? $vuetify.breakpoint.xs
                ? 270
                : 430
              : 430
          " class="w-full" :show-arrows-on-hover="$vuetify.breakpoint.mobile ? false : true" interval="70000">
            <v-carousel-item v-for="(post, i) in blogPosts" :key="i" :src="$connection + post.photoURL">
              <v-container class="relative" fill-height fluid pa-0 ma-0 pb-3>
                <div style="background-color: #f5f7fa !important"
                  class="absolute w-full top-0 subtitle grey--text text--darken-3">
                  <div class="d-flex ml-3" v-html="post.title">
                  </div>
                </div>
              </v-container>
            </v-carousel-item>
          </v-carousel>

          <v-btn :to="{ name: 'Blog' }" color="primary" tile elevation="3" class="mt-5 text-capitalize"
            :class="$vuetify.breakpoint.mobile ? 'mx-5' : ' w-full'" outlined>
            {{ $t("home.info_slogan") }}
          </v-btn>

        </v-col>


        <v-col cols="12" lg="4" :class="$vuetify.breakpoint.mobile ? 'mt-16 ' : ''">
          <div class="text-center">
            <div class="mb-8" :class="$vuetify.breakpoint.mobile ? 'text-h6' : 'text-h5'">
              {{ $t("home.news") }}
            </div>
          </div>
          <div style="max-width: 415px" class="mx-auto">
            <v-divider></v-divider>
            <v-divider></v-divider>
            <div class="news-feed" :class="$vuetify.breakpoint.mobile ? '' : 'text-h5'" v-if="news.length > 0">
              <tgs-news v-for="(info, i) in news" :info="info" :key="i"></tgs-news>
            </div>
            <div v-else class="grey--text text-center">
              {{ $t("no_data_loaded") }}
            </div>
            <v-divider></v-divider>
            <v-divider></v-divider>
          </div>
        </v-col>
      </v-row>


      <scroll-to selector="#offers">
        <template #title>{{ $t("home.offers") }}</template>
        <template #content>
          <div class="text-body-2 grey--text text--darken-2 mb-n5 font-weight-medium"
            :class="$vuetify.breakpoint.mobile ? 'px-5' : ''">
            {{ $t("home.offer_slogan") }}
            <span class="primary--text text-subtitle-2">!</span>
          </div>
          <!-- <SearchBar /> -->

          <div class="mt-8 pa-0 align-center" :class="$vuetify.breakpoint.mobile ? 'px-5' : 'd-flex h-10'">
            <div class="d-flex" :class="$vuetify.breakpoint.mobile ? 'mt-2' : 'max-w-xs'">
              <v-text-field type="number" dense hide-details clearable outlined v-model="age_from" name="name"
                :label="$t('home.age_from')"></v-text-field>
              <v-btn icon text>
                <v-icon>mdi-minus</v-icon>
              </v-btn>
              <v-text-field type="number" outlined clearable v-model="age_to" dense hide-details name="name"
                :label="$t('home.age_to')"></v-text-field>
            </div>
            <div class="" :class="$vuetify.breakpoint.mobile ? 'mt-2' : 'w-64 ml-5'">
              <v-select :menu-props="{ offsetY: true }" v-model="selectedGender" outlined item-text="name"
                item-value="name" width="100px" clearable hide-details :label="$t('home.gender_title')" :items="gender"
                dense>
                <template v-slot:item="{ item }">
                  <v-icon class="mr-2" :color="item.color">mdi-tshirt-crew</v-icon>
                  <span>{{ item.name }}</span>
                </template>
                <template v-slot:selection="{ item }">
                  <v-icon class="mr-2" :color="item.color">mdi-tshirt-crew</v-icon>
                  <span>{{ item.name }},</span>
                </template>
              </v-select>
            </div>
            <div class="" :class="$vuetify.breakpoint.mobile ? 'mt-2' : 'w-64 ml-5'">
              <v-select :menu-props="{ offsetY: true }" v-model="selectedSport" outlined item-text="title"
                item-value="title" width="100px" hide-details clearable :label="$t('home.sports_title')"
                :items="categories" dense>
                <template v-slot:item="{ item }">
                  <v-icon class="mr-2" :color="item.color">{{
                      item.icon
                  }}</v-icon>
                  <span>{{ $t(item.name) }}</span>
                </template>
                <template v-slot:selection="{ item }">
                  <v-icon class="mr-2" :color="item.color">{{
                      item.icon
                  }}</v-icon>
                  <span>{{ $t(item.name) }}</span>
                </template>
              </v-select>
            </div>
            <div class="" style="flex-grow: 4" :class="$vuetify.breakpoint.mobile ? 'mt-2' : 'ml-5'">
              <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('home.search')" single-line outlined
                clearable dense hide-details full-width></v-text-field>
            </div>
          </div>
          <v-divider class="w-full mt-5 mb-n5"></v-divider>
          <div v-if="courses.length > 0">
            <transition-group name="projects" class="projects d-flex flex-wrap w-full mt-10"
              :class="$vuetify.breakpoint.mobile ? 'justify-center' : 'justify-center'">
              <v-col cols="12" md="4" xl="3" v-for="course in filteredCourses" :key="course._id"
                class="project max-w-xs">
                <router-link :to="
                  '/de/abteilung/' +
                  course.department.name +
                  '#' +
                  course.title.toLowerCase()
                " class="text-decoration-none">
                  <ProductCard :course="course" />
                </router-link>
              </v-col>
            </transition-group>
          </div>
          <div v-else class="grey--text text-center mt-16">
            <v-divider></v-divider>
            <v-divider></v-divider>
            {{ $t("no_data_loaded") }}
            <v-divider></v-divider>
            <v-divider></v-divider>
          </div>
        </template>
      </scroll-to>
      <div class="mt-16"></div>
      <scroll-to selector="#workshops">
        <template #title>
          {{ $t("nav.workshops") }}
          <span class="primary--text">!</span>
        </template>
        <template #content>
          <div class="text-center text-h6">
            {{ $t("home.workshop_slogan") }}
          </div>
          <div v-if="workshops.length > 0" class="d-flex flex-wrap w-full px-xs-5 px-lg-16 mt-6">
            <v-col cols="12" md="6" class="my-5" v-for="(workshop, i) in workshops" :key="i" :class="
              i % 2 === 0 && !$vuetify.breakpoint.mdAndDown
                ? 'pr-10'
                : 'pl-sm-10'
            ">
              <router-link :to="
                '/de/workshop' +
                '#' +
                workshop.title.toLowerCase().replace(/ /g, '')
              " class="text-decoration-none">
                <WorkshopCard :item="workshop" :index="i" />
              </router-link>
            </v-col>
          </div>
          <div v-else class="grey--text text-center mt-16">
            <v-divider></v-divider>
            <v-divider></v-divider>
            {{ $t("no_data_loaded") }}
            <v-divider></v-divider>
            <v-divider></v-divider>
          </div>
        </template>
      </scroll-to>
      <div class="pb-16 pt-16"></div>

      <scroll-to selector="#blogposts">
        <template #title>
          {{ $t("home.blog_title.before") }}
          <span class="primary--text">{{ $t("home.blog_title.middle") }}</span>
          -{{ $t("home.blog_title.after") }}.
        </template>
        <template #content>
          <div class="text-center text-h6">{{ $t("home.blog_slogan") }}</div>

          <v-slide-group v-if="blogPosts.length > 0" v-model="model" center-active class="mt-8">
            <v-slide-item v-for="(post, i) in blogPosts" :key="i" v-slot:default="{ active, toggle }">
              <v-card tile flat max-width="300px" @click="toggle" class="px-2 py-4 transparent">
                <BlogPost hideDetails :post="post" />
              </v-card>
            </v-slide-item>
          </v-slide-group>
          <div v-else class="grey--text text-center mt-16">
            <v-divider></v-divider>
            <v-divider></v-divider>
            {{ $t("no_data_loaded") }}
            <v-divider></v-divider>
            <v-divider></v-divider>
          </div>

          <v-row class="mt-10 justify-center">
            <v-btn :to="{ name: 'Blog' }" color="primary" large elevation="5" class="text-capitalize px-16" tile>
              {{ $t("home.go_to_posts") }}
            </v-btn>
          </v-row>
        </template>
      </scroll-to>
      <div class="h-40"></div>
    </div>
    <div :class="$vuetify.breakpoint.mobile ? 'white' : 'white'">
      <scroll-to selector="#sponsors">
        <template #title>{{ $t("home.sponsors_title") }}</template>
        <template #content>
          <div class="d-flex flex-wrap justify-center mt-16 max-w-9xl mx-auto" v-if="sponsors.length > 0">
            <TgsHomepageSponsor v-for="(sponsor, index) in sponsors" :key="index" :sponsor="sponsor" :index="index"
              :sponsor_length="sponsors.length" />
          </div>
          <div v-else class="grey--text text-center mt-16">
            <v-divider></v-divider>
            <v-divider></v-divider>
            {{ $t("no_data_loaded") }}
            <v-divider></v-divider>
            <v-divider></v-divider>
          </div>
        </template>
      </scroll-to>
      <div :class="$vuetify.breakpoint.xs ? '' : 'h-64'"></div>
    </div>
    <scroll-to class="" selector="#contact" style="margin-bottom: 1px">
      <template #title>{{ $t("contact") }}</template>
      <template #content>
        <v-row id="business" class="container mx-auto mt-10">
          <v-col cols="12" md="6" class="pr-10">
            <div class="text-h6">Kontaktiern Sie uns</div>
            <div class="mt-2">
              Bei Fragen die Ihnen unsere Formulare nicht beantworten können,
              würden wir uns freuen wenn Sie uns kontaktieren, damit wir Ihnen
              weiter helfen können.
            </div>
            <div class="mt-10">
              <v-list :dense="$vuetify.breakpoint.mobile" :class="$vuetify.breakpoint.xs ? 'transparent' : ''">
                <v-divider v-show="$vuetify.breakpoint.mobile" inset></v-divider>

                <v-list-item :link="$vuetify.breakpoint.xs" :to="{ name: 'Formulare' }" class="list-hover-yellow">
                  <v-list-item-icon>
                    <v-icon v-if="config.icons" :class="$vuetify.breakpoint.mobile ? 'list-yellow' : ''">{{
                        config.icons.forms.icon
                    }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title class="grey--text text--darken-4">{{
                      $t("nav.formulars")
                  }}</v-list-item-title>
                </v-list-item>

                <v-divider v-show="$vuetify.breakpoint.mobile" inset></v-divider>

                <v-list-item link class="list-hover-green">
                  <v-list-item-icon>
                    <v-icon :class="$vuetify.breakpoint.mobile ? 'list-green' : ''">mdi-phone</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title class="grey--text text--darken-4">{{ $t("phone") }}:
                    <a style="text-decoration: none; color: black" href="tel:061967613888">06196 761-388-8</a>
                  </v-list-item-title>
                </v-list-item>

                <v-divider v-show="$vuetify.breakpoint.mobile" inset></v-divider>

                <v-list-item link class="list-hover-blue">
                  <v-list-item-icon>
                    <v-icon :class="$vuetify.breakpoint.mobile ? 'list-blue' : ''">mdi-email</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title class="grey--text text--darken-4">{{ $t("email") }}:
                    <a style="text-decoration: none; color: black"
                      href="mailto:info@tgschwalbach.de">info@tgschwalbach.de</a>
                  </v-list-item-title>
                </v-list-item>

                <v-divider v-show="$vuetify.breakpoint.mobile" inset></v-divider>

                <v-list-item link class="list-hover-red"
                  href="https://www.google.com/maps/place/Turngemeinde+Schwalbach/@50.1501987,8.5320043,17.5z/data=!4m5!3m4!1s0x0:0xba90ba4fe6162e91!8m2!3d50.14972!4d8.53172">
                  <v-list-item-icon>
                    <v-icon :class="$vuetify.breakpoint.mobile ? 'list-red' : ''">mdi-google-maps</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title class="grey--text text--darken-4">{{ $t("look_at_maps") }}
                  </v-list-item-title>
                  <v-spacer></v-spacer>

                  <small v-show="!$vuetify.breakpoint.mobile" class="grow align-self-end grey--text">{{ $t("to_maps")
                  }}</small>
                </v-list-item>
                <v-divider v-show="$vuetify.breakpoint.mobile" inset></v-divider>
              </v-list>
            </div>
          </v-col>
          <v-col cols="12" md="6" class="">
            <v-card max-width="450" :height="$vuetify.breakpoint.mobile ? 'auto' : 500" class="ml-auto" tile
              :class="$vuetify.breakpoint.mobile ? '' : '-mb-40'" elevation="5">
              <div class="pa-10 pb-5 d-flex flex-column justify-between h-full">
                <div>
                  <div class="text-h5">
                    ... oder besuchen Sie uns
                    <span class="primary--text">direkt vor Ort</span> in unserer
                    Geschäftsstelle
                  </div>
                  <div class="mt-10">
                    <div class="d-flex mt-3">
                      <div>
                        <v-icon>mdi-home-city-outline</v-icon>
                      </div>
                      <div class="ml-5">65824 Schwalbach</div>
                    </div>
                    <div class="d-flex mt-3">
                      <div>
                        <v-icon>mdi-map-marker-radius-outline</v-icon>
                      </div>
                      <div class="ml-5">Jahnstraße 8</div>
                    </div>
                    <v-divider class="mt-5"></v-divider>
                    <div class="d-flex mt-3">
                      <div>
                        <v-icon>mdi-calendar-today</v-icon>
                      </div>
                      <div class="ml-5">{{ $t("tuesday") }}</div>
                    </div>
                    <div class="d-flex mt-3">
                      <div class="ml-11">15:30 Uhr - 17:30 Uhr</div>
                    </div>
                    <v-divider class="mt-3 ml-11"></v-divider>

                    <div class="d-flex mt-3">
                      <div>
                        <v-icon>mdi-calendar-today</v-icon>
                      </div>
                      <div class="ml-5">{{ $t("thursday") }}</div>
                    </div>
                    <div class="d-flex mt-3">
                      <div class="ml-11">10:00 Uhr - 12:00 Uhr</div>
                    </div>
                  </div>
                </div>
                <v-spacer></v-spacer>
                <small class="primary--text d-flex" :class="$vuetify.breakpoint.mobile ? 'mt-7' : ''">
                  <v-icon class="align-self-start" small color="green">mdi-virus-outline</v-icon>
                  <div class="ml-3">{{ $t("times_can_vary") }}</div>
                </small>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <div class="pt-16 primary">
          <div class="container white--text">
            <div class="text-h5 font-weight-bold">Turngemeinde-Schwalbach</div>
            <div class="text-h6">seit 1887 e.V.</div>
            <v-row>
              <v-col cols="12" md="4" class="pt-10 grow text-wrap">
                <div class="font-weight-bold">Schlusswort:</div>
                <div class="mt-2">
                  Die Turngemeinde Schwalbach wurde 1887 gegründet. Seither
                  diente sie über die Zeit hinweg unzähligen Sortbegeisterten
                  als Ort der Zusammenkunft und des Austauschs. Wir würden uns
                  freuen Dich demnächst als Teil dieser Gemeinschaft begrüßen zu
                  können!
                </div>
                <div class="mt-2 dancing font-weight-bold">Dein TGS-Team</div>
              </v-col>
              <v-col cols="12" md="4" class="pt-10 grow">
                <div class="font-weight-bold">Kontakt:</div>
                <p class="mt-2">
                  Kontaktieren Sie uns gerne über das oben stehende Fromular
                  oder kommen Sie persönlich bei uns vorbei.
                </p>
                <div>
                  <span class="font-weight-bold">Tel:</span> 06196 761-388-8
                </div>
                <div>
                  <span class="font-weight-bold">E-Mail:</span>
                  info@tgschwalbach.de
                </div>
              </v-col>
              <v-col cols="12" md="4" class="pt-10 grow">
                <div class="font-weight-bold">Soziale Medien</div>
                <div class="mt-2 d-flex">
                  <a href="https://www.facebook.com/tgschwalbach/">
                    <v-btn icon>
                      <v-icon large color="white">mdi-facebook</v-icon>
                    </v-btn>
                  </a>
                  <!-- <a href="https://www.facebook.com/tgschwalbach/">
                    <v-btn icon>
                      <v-icon large color="white">mdi-facebook</v-icon>
                    </v-btn>
                  </a> -->
                </div>
              </v-col>
            </v-row>
            <div class="h-px white mt-5 hidden-md-and-up"></div>
            <v-toolbar class="mt-5 justify-center white--text d-flex primary" flat
              :style="{ height: $vuetify.breakpoint.mobile ? '370px' : 'auto' }" dark>
              <v-toolbar-items exact :class="$vuetify.breakpoint.mobile ? ' flex-column' : ''">
                <template v-for="(note, i) in footer">
                  <v-btn v-if="note.isRoute" :to="{ name: note.route }" text :key="i">{{ note.name }}</v-btn>
                  <v-tooltip v-else :key="i" top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn :href="note.href" text v-bind="attrs" v-on="on">
                        {{ note.name }}
                        <v-icon small class="ml-2">{{ note.icon }}</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("opens_pdf") }}</span>
                  </v-tooltip>

                  <v-divider class="hidden-md-and-down" v-if="i + 1 !== footer.length" :key="i + footer.length"
                    :vertical="!$vuetify.breakpoint.mobile" :horizontal="$vuetify.breakpoint.mobile" inset></v-divider>
                </template>
              </v-toolbar-items>
            </v-toolbar>
          </div>
        </div>
      </template>
    </scroll-to>
  </div>
</template>


<script>
import TgsNews from "@/components/TgsNews";
import ScrollTo from "@/components/ScrollTo";
// import SearchBar from "@/components/SearchBar";
import ProductCard from "@/components/ProductCard";
import BlogPost from "@/components/BlogPost";
import WorkshopCard from "@/components/WorkshopCard";
import Breadcrumb from "@/components/Breadcrumb";
// import CoronaDialog from "@/components/dialogs/CoronaDialog";
import TgsHomepageSponsor from "@/components/TgsHomepageSponsor";
export default {
  name: "",
  components: {
    TgsHomepageSponsor,
    Breadcrumb,
    WorkshopCard,
    // CoronaDialog,
    BlogPost,
    ProductCard,
    // SearchBar,
    ScrollTo,
    TgsNews,
  },
  data() {
    return {
      selectedGender: "",
      search: "",
      age_from: null,
      age_to: null,
      selectedSport: "",
      gender: [
        { name: "männlich", color: "blue lighten-3" },
        { name: "weiblich", color: "pink lighten-3" },
        { name: "divers", color: "green lighten-3" },
      ],
      footer: [
        { icon: "", isRoute: true, name: "Impressum", route: "Impress" },
        { icon: "mdi-file-pdf-outline", isRoute: false, href: `${this.$connection}/forms/Vorstand.pdf`, name: "Vorstand", route: "Vorstand" },
        {
          icon: "mdi-file-pdf-outline",
          isRoute: false,
          href: `${this.$connection}/forms/Satzung.pdf`,
          name: "Satzung",
          route: "Satzung",
        },
        {
          icon: "mdi-file-pdf-outline",
          isRoute: false,
          href: `${this.$connection}/forms/Schutzkonzept.pdf`,
          name: "Schutzkonzept",
          route: "Schutzkonzept",
        },
        {
          icon: "mdi-file-pdf-outline",
          isRoute: false,
          href: `${this.$connection}/forms/Finanz- und Beitragsordnung.pdf`,
          name: "Finanz- und Beitragsordnung",
          route: "Finanz- und Beitragsordnung",
        },
        {
          icon: "mdi-file-pdf-outline",
          isRoute: false,
          href: `${this.$connection}/forms/Jugendordnung.pdf`,
          name: "Jugendordnung",
          route: "Jugendordnung",
        },
         {
          icon: "mdi-file-pdf-outline",
          isRoute: false,
          href: `${this.$connection}/forms/Datenschutzordnung.pdf`,
          name: "Datenschutzordnung",
          route: "Datenschutzordnung",
        },
        {
          icon: "",
          isRoute: true,
          name: "Datenschutzerklärung",
          route: "Privacy",
        },
        {
          icon: "",
          isRoute: true,
          name: "Haftungsausschluss",
          route: "ExclusionOfLiability",
        },
      ],
      model: "",
      selectors: [
        "#offers",
        "#workshops",
        "#blogposts",
        "#sponsors",
        "#contact",
      ],
    };
  },

  methods: {
    options() {
      return {
        duration: 2000,
        offset: 100,
        easing: "easeInOutCubic",
      };
    },

    openInNewTab(link) {
      window.open(link, "_blank");
    },
    sideScroll(element, direction, speed, distance, step) {
      let scrollAmount = 0;
      var slideTimer = setInterval(function () {
        if (direction == "left") {
          element.scrollLeft -= step;
        } else {
          element.scrollLeft += step;
        }
        scrollAmount += step;
        if (scrollAmount >= distance) {
          window.clearInterval(slideTimer);
        }
      }, speed);
    },
  },

  computed: {
    filteredCourses() {
      return this.courses
        .filter((course) =>
          this.selectedSport
            ? course.categories.filter(
              (cat) => this.selectedSport === cat.title
            ).length > 0
            : true
        )
        .filter((course) =>
          this.search
            ? course.title.toLowerCase().includes(this.search.toLowerCase())
            : true
        )
        .filter((course) =>
          this.selectedGender
            ? course.genders.includes(this.selectedGender)
            : true
        )
        .filter((course) =>
          this.age_from ? parseInt(course.age_from) <= this.age_from && parseInt(course.age_to) > this.age_from : true
        )
        .filter((course) =>
          this.age_to ? parseInt(course.age_to) >= this.age_to && parseInt(course.age_from) < this.age_to : true
        ).sort((a, b) => a.title.localeCompare(b.title));
    },
    categories() {
      return this.$store.getters["publicApi/getCourses"]
        .map((course) => course.categories)
        .flat();
    },
    config() {
      return this.$store.getters["config/getConfig"];
    },
    news() {
      return this.$store.getters["publicApi/getNews"];
    },
    blogPosts() {
      return this.$store.getters["publicApi/getBlogPosts"];
    },
    sponsors() {
      return this.$store.getters["publicApi/getSponsorsHomepage"];
    },
    courses() {
      return this.$store.getters["publicApi/getCourses"];
    },
    workshops() {
      return this.$store.getters["publicApi/getWorkshops"];
    },
  },

  created() {
    // this.$store.commit('UPDATE_BREADCRUMB', '');
    window.scrollTo(0, this.pageHeight);
    this.$store.dispatch("publicApi/getBlogPosts");
    this.$store.dispatch("publicApi/getNews");
    this.$store.dispatch("publicApi/getCourses");
    this.$store.dispatch("publicApi/getSponsorsHomepage");
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/main.scss";

.clipped-bg {
  clip-path: polygon(0 0, 100% 11%, 100% 90%, 0% 100%);
  background-color: #fff;
}

* {
  box-sizing: border-box;
}

#background-image {
  // position: absolute;
  width: 100%;
  max-height: 500px;
  left: 0;
  top: 0;
  margin-top: -128px;
}

.distance {
  margin-top: 400px;
}

.news-feed {
  overflow-y: scroll;
  max-height: 485px;
}

.offer-cards {
  overflow-x: scroll;
  height: 601px;
  position: relative;
}

.list-hover-yellow:hover {
  .v-list-item__icon {
    i {
      color: #ffc400 !important;
    }
  }
}

.list-hover-green:hover {
  .v-list-item__icon {
    i {
      color: #388e3c !important;
    }
  }
}

.list-hover-blue:hover {
  .v-list-item__icon {
    i {
      color: #2979ff !important;
    }
  }
}

.list-hover-red:hover {
  .v-list-item__icon {
    i {
      color: #ff1744 !important;
    }
  }
}

.list-yellow {
  color: #ffc400 !important;
}

.list-green {
  color: #388e3c !important;
}

.list-blue {
  color: #2979ff !important;
}

.list-red {
  color: #ff1744 !important;
}

.box {
  background-color: #3D6AA2;
  width: 160px;
  height: 90px;
  position: absolute;
  top: calc(10% - 10px);
  left: calc(50% - 80px);
}

.box-shadow:after {
  content: "";
  position: absolute;
  width: 100%;
  bottom: 1px;
  z-index: -1;
  transform: scale(0.9);
  box-shadow: 0px 0px 8px 2px #000000;
}

* {
  scroll-behavior: smooth;
}

.project-title {
  font-size: 16pt;
}

.filter {
  font-family: arial;
  padding: 6px 6px;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.35s;
}

.filter.active {
  box-shadow: 0px 1px 3px 0px #00000026;
}

.filter:hover {
  background: lightgray;
}

.projects {
  margin-bottom: 50px;
  margin-top: 25px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.projects-enter {
  transform: scale(0.5) translatey(-80px);
  opacity: 0;
}

.projects-leave-to {
  transform: translatey(30px);
  opacity: 0;
}

.projects-leave-active {
  position: absolute;
  z-index: -1;
}

.circle {
  text-align: center;
  position: absolute;
  bottom: -38px;
  left: 40px;
  width: 100px;
  height: 100px;
  border-radius: 50px;
  /* 	border:1px solid black; */
  display: flex;
  box-shadow: 0px -4px 3px 0px #494d3257;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  /* 	box-shadow:0px -3px 3px #484848a6; */
}

.project {
  transition: all 0.35s ease-in-out;
}

.project-image-wrapper {
  position: relative;
}

.gradient-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 150px;
  opacity: 0.09;
  background: linear-gradient(to bottom,
      rgba(0, 210, 247, 0.65) 0%,
      rgba(0, 210, 247, 0.64) 1%,
      rgba(0, 0, 0, 0) 100%),
    linear-gradient(to top,
      rgba(247, 0, 156, 0.65) 0%,
      rgba(247, 0, 156, 0.64) 1%,
      rgba(0, 0, 0, 0) 100%);
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.project-image {
  width: 100%;
  height: 150px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}
</style>
